module.exports = __webpack_public_path__ + "td.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/td.svg
// module id = 1087
// module chunks = 0